import * as React from "react";
import { Heart, Quote } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function ExpertNote() {
  return <section data-section-id="224399" id="your-local-guide" className="bg-background text-foreground py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-40">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-accent/40 blur-3xl" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-accent/40 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div className="relative md:-translate-y-12">
            <div className="absolute -inset-4 bg-accent/50 rounded-3xl transform -rotate-3 border border-white/40 shadow-sm hidden md:block"></div>
            <div className="relative rounded-3xl overflow-hidden shadow-xl border border-white/60 bg-card">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/ChatGPT Image May 6, 2026, 05_18_39 PM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/ChatGPT Image May 6, 2026, 05_18_39 PM.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/ChatGPT Image May 6, 2026, 05_18_39 PM.png-wvc-sizes" alt="Anish Patel - Local Market Expert" className="w-full h-auto object-cover aspect-[4/5] object-top" loading="lazy" />
            </div>
            
            <div className="mt-10 flex flex-col gap-4 px-2">
              <div className="flex flex-col">
                <span className="font-serif italic text-3xl text-primary tracking-tight">Anish Patel, MBA</span>
                <span className="font-serif italic text-2xl text-primary/80 tracking-tight">Realtor</span>
                <span className="font-serif italic text-lg text-primary/70 tracking-tight">Mobile: 815-546-0725</span>
              </div>
              <Link to="/" className="relative z-20 shrink-0 !bg-[url(https://happy-werewolf.10web.cloud/wp-content/uploads/2026/04/IMG_0002.png)] !bg-[url(https://happy-werewolf.10web.cloud/wp-content/uploads/2026/04/image_1o5x5vl2.png)]"><br /></Link>
            </div>

            {}
            
          </div>

          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <div className="flex flex-wrap items-center gap-3">
                <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm font-default">
                  Local Market Expert
                </Badge>
                <Badge variant="outline" className="bg-background/80 backdrop-blur-sm border-primary/20 text-foreground font-default">Sub-$650K Specialist</Badge>
              </div>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground leading-tight relative">
                <Quote className="absolute -top-6 -left-8 size-12 text-primary/10 rotate-180 hidden md:block" />
                "I find the 'hidden gems' Naperville buyers usually miss."
              </h2>
            </div>

            <div className="space-y-5 text-foreground/80 text-lg leading-relaxed font-default">
              <p>
                Home is where the heart is. That’s why I treat every client’s search like it’s my own.
              </p>
              <p>I’ve lived in the Chicagoland suburbs for over 40 years and spent 25+ years leading teams, negotiating complex deals, and helping people make confident decisions.<br /><br />Today, I focus primarily on residential real estate, helping buyers discover hidden gems and better-value opportunities in and around Naperville, Lisle, Plainfield, Oswego, Aurora, Bolingbrook and nearby suburbs.<br /><br />As a real estate investor myself, I understand what makes a property a smart long-term move — whether that means better schools, lower taxes, more space, or stronger value for your budget.</p>
              <p>My goal is simple: help buyers find the lifestyle they want without overpaying in today’s market.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}